/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  addDecoderSizePrefix,
  addEncoderSizePrefix,
  combineCodec,
  getDiscriminatedUnionDecoder,
  getDiscriminatedUnionEncoder,
  getStructDecoder,
  getStructEncoder,
  getU32Decoder,
  getU32Encoder,
  getU8Decoder,
  getU8Encoder,
  getUtf8Decoder,
  getUtf8Encoder,
  type Codec,
  type Decoder,
  type Encoder,
  type GetDiscriminatedUnionVariant,
  type GetDiscriminatedUnionVariantContent,
} from "@solana/kit";

/** Arbitrator's final decision on disputed escrow */
export type ArbitratorDecision =
  | { __kind: "FavorClient"; reason: string }
  | { __kind: "FavorAgent"; reason: string }
  | { __kind: "Split"; clientPercentage: number; reason: string };

export type ArbitratorDecisionArgs = ArbitratorDecision;

export function getArbitratorDecisionEncoder(): Encoder<ArbitratorDecisionArgs> {
  return getDiscriminatedUnionEncoder([
    [
      "FavorClient",
      getStructEncoder([
        ["reason", addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())],
      ]),
    ],
    [
      "FavorAgent",
      getStructEncoder([
        ["reason", addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())],
      ]),
    ],
    [
      "Split",
      getStructEncoder([
        ["clientPercentage", getU8Encoder()],
        ["reason", addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())],
      ]),
    ],
  ]);
}

export function getArbitratorDecisionDecoder(): Decoder<ArbitratorDecision> {
  return getDiscriminatedUnionDecoder([
    [
      "FavorClient",
      getStructDecoder([
        ["reason", addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())],
      ]),
    ],
    [
      "FavorAgent",
      getStructDecoder([
        ["reason", addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())],
      ]),
    ],
    [
      "Split",
      getStructDecoder([
        ["clientPercentage", getU8Decoder()],
        ["reason", addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())],
      ]),
    ],
  ]);
}

export function getArbitratorDecisionCodec(): Codec<
  ArbitratorDecisionArgs,
  ArbitratorDecision
> {
  return combineCodec(
    getArbitratorDecisionEncoder(),
    getArbitratorDecisionDecoder(),
  );
}

// Data Enum Helpers.
export function arbitratorDecision(
  kind: "FavorClient",
  data: GetDiscriminatedUnionVariantContent<
    ArbitratorDecisionArgs,
    "__kind",
    "FavorClient"
  >,
): GetDiscriminatedUnionVariant<
  ArbitratorDecisionArgs,
  "__kind",
  "FavorClient"
>;
export function arbitratorDecision(
  kind: "FavorAgent",
  data: GetDiscriminatedUnionVariantContent<
    ArbitratorDecisionArgs,
    "__kind",
    "FavorAgent"
  >,
): GetDiscriminatedUnionVariant<ArbitratorDecisionArgs, "__kind", "FavorAgent">;
export function arbitratorDecision(
  kind: "Split",
  data: GetDiscriminatedUnionVariantContent<
    ArbitratorDecisionArgs,
    "__kind",
    "Split"
  >,
): GetDiscriminatedUnionVariant<ArbitratorDecisionArgs, "__kind", "Split">;
export function arbitratorDecision<
  K extends ArbitratorDecisionArgs["__kind"],
  Data,
>(kind: K, data?: Data) {
  return Array.isArray(data)
    ? { __kind: kind, fields: data }
    : { __kind: kind, ...(data ?? {}) };
}

export function isArbitratorDecision<K extends ArbitratorDecision["__kind"]>(
  kind: K,
  value: ArbitratorDecision,
): value is ArbitratorDecision & { __kind: K } {
  return value.__kind === kind;
}
